import React from "react";
import UserSettingsDropdown from "../../../ui-kit/src/specialized/navigation/UserSettingsDropdown";
import LazyBrandsNavbarSettingsDropdown from "./BrandsNavbar/LazyBrandsNavbarSettingsDropdown";

function UserCombinedMenu({
                            name,
                            email,
                            handleSettings,
                            hasChangeDetailsPermission,
                            hasManageUsersPermission,
                            handleLogOut,
                            handleAddCompany,
                            canAddCompany,
                            toggleManageApiKeysModal,
                            handleManageMembers,
                            currentCompany,
                            handleCompanyChange,
                          }) {
  return <div className={'d-flex'}>
    <LazyBrandsNavbarSettingsDropdown currentCompany={currentCompany}
                                      handleCompanyChange={handleCompanyChange}
                                      canAddCompany={canAddCompany}
                                      handleAddCompany={handleAddCompany}
                                      toggleManageApiKeysModal={toggleManageApiKeysModal}
                                      canChangeBrand={!!hasChangeDetailsPermission}
                                      canManageMembers={!!hasManageUsersPermission}
                                      handleManageMembers={handleManageMembers}/>
    <UserSettingsDropdown userName={name} userEmail={email} handleSettings={handleSettings}
                          handleLogOut={handleLogOut}/>
  </div>
}

export default UserCombinedMenu;
